"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchWithNotifications = exports.mapStatusToMessage = exports.fetch = exports.post = exports.get = exports.response = void 0;

var axios_1 = __importDefault(require("axios"));

var Credentials = __importStar(require("./credentials"));

exports.response = function (options) {
  return axios_1.default(options);
};

var withCredentials = true;
var responseType = 'json';
var defaultParameters = {
  withCredentials: withCredentials,
  responseType: responseType
};

var getHeaders = function getHeaders() {
  var token = Credentials.getToken();
  return {
    Authorization: 'Bearer ' + token,
    'Content-Type': 'application/json'
  };
};

var formatSuccess = function formatSuccess(x) {
  return x.data;
};

var formatError = function formatError(x) {
  return Promise.reject({
    status: x.response && x.response.status,
    data: x.response && x.response.data
  });
};

exports.get = function (url) {
  var method = 'get';
  var headers = getHeaders();
  var options = Object.assign({
    method: method,
    headers: headers,
    url: url
  }, defaultParameters);
  return exports.response(options).then(formatSuccess, formatError);
};

exports.post = function (url, data) {
  var method = 'post';
  var headers = getHeaders();
  var options = Object.assign({
    method: method,
    headers: headers,
    url: url,
    data: data
  }, defaultParameters);
  return exports.response(options).then(formatSuccess, formatError);
};

exports.fetch = function (url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (data === null || !data) {
    return exports.get(url);
  }

  return exports.post(url, data);
};

exports.mapStatusToMessage = function (status) {
  switch (status) {
    case 200:
    case 201:
      return 'growlAlert.text.save.success';

    case 404:
      return 'growl.notFound.danger';

    case 401:
    case 403:
      return 'growl.unauthorized.danger';

    case 400:
      return null;

    default:
      return 'growl.serverError.danger';
  }
};

exports.fetchWithNotifications = function (url) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return exports.fetch(url, data).then(function (data) {
    return Promise.resolve({
      data: data,
      message: exports.mapStatusToMessage(200)
    });
  }, function (errors) {
    return Promise.reject({
      status: errors.status,
      data: errors.data,
      message: exports.mapStatusToMessage(errors.status)
    });
  });
};

exports.default = {
  response: exports.response,
  get: exports.get,
  post: exports.post,
  fetch: exports.fetch,
  fetchWithNotifications: exports.fetchWithNotifications
};